module.exports = __webpack_public_path__ + "static/media/trimex_Medalla de plata.fab0ecc4.png";